"use client";

export default function RotatingTrophyVideo() {
  return (
    <div className="relative flex items-center justify-center">
      <video
        width={80}
        height={80}
        autoPlay
        loop
        muted
        playsInline
        className="w-[280px] sm:w-[320px] md:w-[320px] lg:w-[320px] 2xl:w-[390px]"
      >
        <source
          src="https://d3fnp7tzd7tmsf.cloudfront.net/2025-assets/trophy_rotating.mov"
          type='video/mp4; codecs="hvc1"'
        />
        <source
          src="https://d3fnp7tzd7tmsf.cloudfront.net/2025-assets/trophy_rotating.webm"
          type="video/webm"
        />
        Your browser does not support the video tag. Your browser does not support the video tag.
      </video>
    </div>
  );
}
